import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigFormScreen } from './ConfigFormScreen';
import { useOgServiceIdentity, useUpdateOgServiceIdentity, } from '@/api/opengater/useSettings';
/** users `admin: service-identity` — service name + site used in notifications. */
export function OpengaterServiceIdentity() {
    const q = useOgServiceIdentity();
    const upd = useUpdateOgServiceIdentity();
    return (_jsx(ConfigFormScreen, { title: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u0430", subtitle: "\u0418\u043C\u044F \u0438 \u0441\u0430\u0439\u0442 \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u2014 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0432 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F\u0445", capability: "service-identity.write", sections: [
            {
                fields: [
                    {
                        key: 'display_name',
                        label: 'Имя сервиса',
                        kind: 'text',
                        hint: 'Отображается в уведомлениях пользователям.',
                        placeholder: 'Opengater',
                    },
                    {
                        key: 'web_url',
                        label: 'Сайт сервиса',
                        kind: 'url',
                        placeholder: 'https://opengater.com',
                    },
                ],
            },
        ], data: q.data, isLoading: q.isLoading, error: q.error, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
